module.exports = __webpack_public_path__ + "static/img/p6.0bb4c8b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/partner/p6.png
// module id = eCXK
// module chunks = 0